import React, { useEffect, useState } from "react";
import { goTo } from "../../App";

export default function TopBar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className="sticky top-0 z-50 transition-all"
      style={{
        backdropFilter: "blur(10px)",
        background: scrolled ? "rgba(1,7,26,0.9)" : "rgba(1,7,26,0.4)",
        borderBottom: `1px solid ${scrolled ? "var(--line)" : "transparent"}`,
      }}
    >
      <div className="mx-auto max-w-[1080px] px-4 h-16 flex items-center justify-between">
        <span className="display" style={{ fontSize: "1.15rem", letterSpacing: "0.02em" }}>
          HIGHTICKET<span className="blue">SALES.IT</span>
        </span>
        <button onClick={() => goTo("live")} className="btn btn-blue" style={{ minHeight: 40, padding: "9px 20px", fontSize: "0.85rem" }}>
          Prenota la live
        </button>
      </div>
    </header>
  );
}
